<template>
<div>
<BasicSchedule/>

</div>
</template>
<script>
import BasicSchedule from "../../components/academic/BasicSchedule.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   BasicSchedule
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>